module.exports = "/shifts/components/shiftTemplateSelectionComponent-a67776.html";